export default __webpack_public_path__ + "static/media/121Logo.9c424797.svg";